<template>
  <div class="login-box">
    <div class="login-top">
      <div class="inline logo">
        <img src="../assets/logo.png" alt=""/>
      </div>
      <div class="inline go-back" @click="$router.go(-1)">返回</div>
      <span class="inline fr">注册</span>
    </div>
    <div class="title tc"></div>
    <div class="login-form">
      <el-form :model="loginForm" label-position="left" ref="loginForm" class="demo-loginForm">
        <el-form-item prop="mobile" :rules="[{ required: true, message: '不能为空' }, { pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号' }]">
          <el-input class="mobileinput" v-model="loginForm.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="username" :rules="[{ required: true, message: '不能为空' }]">
          <el-input class="usernameinput" v-model="loginForm.username" placeholder="请填写真实姓名"></el-input>
        </el-form-item>
        <el-form-item prop="password" :rules="{ required: true, message: '不能为空' }">
          <el-input class="passwordinput" show-password v-model="loginForm.password" placeholder="请输入密码" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item prop="code" :rules="{ required: true, message: '不能为空' }">
          <el-input class="identifyinput" type="number" v-model="loginForm.code" placeholder="请输入验证码" maxlength="200"></el-input>
          <el-button class="identifybox" :loading="loading" :disabled="disabled" type="primary" @click="sendCode">{{s > 0 ? `(${s})s` : '发送验证码'}}</el-button>
        </el-form-item>
      </el-form>
      <!-- <div class="txt">
        <a class="inline">登陆</a>
        <a class="fr">忘记密码？</a>
      </div> -->
      <el-button type="primary" round :loading="btnLoading" @click="handleLogin" class="login-submit yoo-button-1">注册</el-button>
    </div>
  </div>
</template>

<script>
import { reg, sendsms } from '@/api'
export default {
  data () {
    return {
      loginForm: {
        mobile: '',
        password: '',
        username: '',
        code: ''
      },
      btnLoading: false,
      s: 0,
      timer: null,
      disabled: false,
      loading: false
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.submit()
        }
      })
    },
    submit () {
      this.btnLoading = true
      var formData = new FormData()
      formData.append('username', this.loginForm.username)
      formData.append('mobile', this.loginForm.mobile)
      formData.append('password', this.loginForm.password)
      formData.append('deviceid', this.$route.query.device)
      formData.append('code', this.loginForm.code)
      reg(formData).then(res => {
        if (res.detail) {
          this.$notify.error({
            message: res.detail,
            showClose: false,
            offset: 100,
            duration: 2000
          })
        } else {
          this.$confirm(res.msg + ',去登陆', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info',
            center: true
          }).then(() => {
            this.$router.push({path: '/login', query: {device: this.$route.query.device, hospital: this.$route.query.hospital}})
          })
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    sendCode () {
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (this.loginForm.mobile) {
        this.loading = true
        var formData = new FormData()
        formData.append('mobile', this.loginForm.mobile)
        formData.append('type', 'register')
        sendsms(formData).then(res => {
          this.$notify.success({
            message: res.msg,
            showClose: false,
            offset: 100,
            duration: 2000
          })
          this.s = 60
          this.disabled = true
          let _this = this
          this.timer = setInterval(() => {
            if (_this.s <= 0) {
              clearInterval(_this.timer)
              _this.disabled = false
            } else {
              _this.s--
            }
          }, 1000)
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$notify.error({
          message: '请输入手机号',
          showClose: false,
          offset: 100,
          duration: 2000
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// .login-form{
//   width: 80%;
//   padding: 8%;
//   margin: auto;
//   // height: 80%;
//   // background: #fff;
//   // border: 1px solid #cccccc;
//   // box-shadow: 0px 3px 13px 0px rgb(117, 117, 117);
//   border-radius: 10px;
// }
</style>



// WEBPACK FOOTER //
// src/views/register.vue